import moment from "moment";

export const filterDates = (policy, dateProperty, duration) => {
  // Get the date from when we want data
  const firstDay = moment().subtract(duration, "months");

  // Check if policy is greater then required date
  return moment(policy[dateProperty]).isAfter(firstDay);
};
